/* tslint:disable */
import {
  PayeeAccountDetail,
  PayeeDetail,
  PayeeShareholder,
  PayeeAttachment,
  PayeeWebChecklist,
  PayeePaymentProcessing,
  PayeeBusinessSales,
  PayeeEStatementAdmin,
  PayeeECommerceAdmin,
  PayeeReportingPdp,
  PayeeSalesHistory,
  PayeeService,
  PayeeServiceDPE,
  PayeeServiceM2Ubiller,
  PayeeSubmission,
  PayeePosOutlet,
  PayeePos,
  PayeeFraudChecklist,
  PayeePCIDSS,
  PayeePosPaymentProcessing,
  PayeePosEstatementAdmin,
  PayeeJompay,
  PayeeJompayAccount,
  PayeeJompayReportingPdp
} from '../index';

declare var Object: any;
export interface PayeeInterface {
  "first_name": string;
  "last_name": string;
  "email": string;
  "approved"?: boolean;
  "login_attempt"?: number;
  "pre_form_declaration"?: boolean;
  "created_at"?: Date;
  "updated_at"?: Date;
  "password"?: string;
  accessTokens?: any[];
  m2uPayAccountDetails?: PayeeAccountDetail;
  details?: PayeeDetail;
  shareholders?: PayeeShareholder[];
  attachments?: PayeeAttachment[];
  cmoWebChecklist?: PayeeWebChecklist[];
  paymentProcessing?: PayeePaymentProcessing;
  businessSales?: PayeeBusinessSales;
  eStatementAdmin?: PayeeEStatementAdmin[];
  eCommerceAdmin?: PayeeECommerceAdmin[];
  pdpReporting?: PayeeReportingPdp[];
  salesHistory?: PayeeSalesHistory;
  services?: PayeeService[];
  m2uPay?: PayeeServiceDPE;
  m2uBiller?: PayeeServiceM2Ubiller;
  submissions?: PayeeSubmission[];
  outlets?: PayeePosOutlet[];
  pos?: PayeePos;
  fraudChecklist?: PayeeFraudChecklist;
  PCIDSS?: PayeePCIDSS;
  posPaymentProcessing?: PayeePosPaymentProcessing;
  posEStatementAdmin?: PayeePosEstatementAdmin[];
  jompay?: PayeeJompay;
  jompay_account?: PayeeJompayAccount;
  jompay_reporting_pdps?: PayeeJompayReportingPdp[];
}

export class Payee implements PayeeInterface {
  "first_name": string;
  "last_name": string;
  "email": string;
  "approved": boolean;
  "login_attempt": number;
  "pre_form_declaration": boolean;
  "created_at": Date;
  "updated_at": Date;
  "password": string;
  accessTokens: any[];
  m2uPayAccountDetails: PayeeAccountDetail;
  details: PayeeDetail;
  shareholders: PayeeShareholder[];
  attachments: PayeeAttachment[];
  cmoWebChecklist: PayeeWebChecklist[];
  paymentProcessing: PayeePaymentProcessing;
  businessSales: PayeeBusinessSales;
  eStatementAdmin: PayeeEStatementAdmin[];
  eCommerceAdmin: PayeeECommerceAdmin[];
  pdpReporting: PayeeReportingPdp[];
  salesHistory: PayeeSalesHistory;
  services: PayeeService[];
  m2uPay: PayeeServiceDPE;
  m2uBiller: PayeeServiceM2Ubiller;
  submissions: PayeeSubmission[];
  outlets: PayeePosOutlet[];
  pos: PayeePos;
  fraudChecklist: PayeeFraudChecklist;
  PCIDSS: PayeePCIDSS;
  posPaymentProcessing: PayeePosPaymentProcessing;
  posEStatementAdmin: PayeePosEstatementAdmin[];
  jompay: PayeeJompay;
  jompay_account: PayeeJompayAccount;
  jompay_reporting_pdps: PayeeJompayReportingPdp[];
  constructor(data?: PayeeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Payee`.
   */
  public static getModelName() {
    return "Payee";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Payee for dynamic purposes.
  **/
  public static factory(data: PayeeInterface): Payee{
    return new Payee(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Payee',
      plural: 'users',
      path: 'users',
      idName: 'id',
      properties: {
        "first_name": {
          name: 'first_name',
          type: 'string'
        },
        "last_name": {
          name: 'last_name',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "approved": {
          name: 'approved',
          type: 'boolean'
        },
        "login_attempt": {
          name: 'login_attempt',
          type: 'number'
        },
        "pre_form_declaration": {
          name: 'pre_form_declaration',
          type: 'boolean'
        },
        "created_at": {
          name: 'created_at',
          type: 'Date'
        },
        "updated_at": {
          name: 'updated_at',
          type: 'Date'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        m2uPayAccountDetails: {
          name: 'm2uPayAccountDetails',
          type: 'PayeeAccountDetail',
          model: 'PayeeAccountDetail',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        details: {
          name: 'details',
          type: 'PayeeDetail',
          model: 'PayeeDetail',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        shareholders: {
          name: 'shareholders',
          type: 'PayeeShareholder[]',
          model: 'PayeeShareholder',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        attachments: {
          name: 'attachments',
          type: 'PayeeAttachment[]',
          model: 'PayeeAttachment',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        cmoWebChecklist: {
          name: 'cmoWebChecklist',
          type: 'PayeeWebChecklist[]',
          model: 'PayeeWebChecklist',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        paymentProcessing: {
          name: 'paymentProcessing',
          type: 'PayeePaymentProcessing',
          model: 'PayeePaymentProcessing',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        businessSales: {
          name: 'businessSales',
          type: 'PayeeBusinessSales',
          model: 'PayeeBusinessSales',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        eStatementAdmin: {
          name: 'eStatementAdmin',
          type: 'PayeeEStatementAdmin[]',
          model: 'PayeeEStatementAdmin',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        eCommerceAdmin: {
          name: 'eCommerceAdmin',
          type: 'PayeeECommerceAdmin[]',
          model: 'PayeeECommerceAdmin',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        pdpReporting: {
          name: 'pdpReporting',
          type: 'PayeeReportingPdp[]',
          model: 'PayeeReportingPdp',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        salesHistory: {
          name: 'salesHistory',
          type: 'PayeeSalesHistory',
          model: 'PayeeSalesHistory',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        services: {
          name: 'services',
          type: 'PayeeService[]',
          model: 'PayeeService',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        m2uPay: {
          name: 'm2uPay',
          type: 'PayeeServiceDPE',
          model: 'PayeeServiceDPE',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        m2uBiller: {
          name: 'm2uBiller',
          type: 'PayeeServiceM2Ubiller',
          model: 'PayeeServiceM2Ubiller',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        submissions: {
          name: 'submissions',
          type: 'PayeeSubmission[]',
          model: 'PayeeSubmission',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        outlets: {
          name: 'outlets',
          type: 'PayeePosOutlet[]',
          model: 'PayeePosOutlet',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        pos: {
          name: 'pos',
          type: 'PayeePos',
          model: 'PayeePos',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        fraudChecklist: {
          name: 'fraudChecklist',
          type: 'PayeeFraudChecklist',
          model: 'PayeeFraudChecklist',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        PCIDSS: {
          name: 'PCIDSS',
          type: 'PayeePCIDSS',
          model: 'PayeePCIDSS',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        posPaymentProcessing: {
          name: 'posPaymentProcessing',
          type: 'PayeePosPaymentProcessing',
          model: 'PayeePosPaymentProcessing',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        posEStatementAdmin: {
          name: 'posEStatementAdmin',
          type: 'PayeePosEstatementAdmin[]',
          model: 'PayeePosEstatementAdmin',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        jompay: {
          name: 'jompay',
          type: 'PayeeJompay',
          model: 'PayeeJompay',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        jompay_account: {
          name: 'jompay_account',
          type: 'PayeeJompayAccount',
          model: 'PayeeJompayAccount',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
        jompay_reporting_pdps: {
          name: 'jompay_reporting_pdps',
          type: 'PayeeJompayReportingPdp[]',
          model: 'PayeeJompayReportingPdp',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'payee_id'
        },
      }
    }
  }
}
